export class AsciiMapper {
  static toValue(char: string): number {
    return char.toUpperCase().charCodeAt(0) - 48;
  }
}